import { render, staticRenderFns } from "./FloorCount.vue?vue&type=template&id=6271c4d4&"
import script from "./FloorCount.vue?vue&type=script&lang=ts&"
export * from "./FloorCount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports